var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-switch',{attrs:{"active-text":_vm.activeText,"active-color":_vm.uiVariable.color.purple,"inactive-color":_vm.uiVariable.color.purple2,"inactive-text":_vm.inactiveText},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }